import React from 'react';
import { SubTitle } from 'components';
import Tab from '../Tab';
import AccordionUI from '../../components/Accordion';
import { SectionContainer } from 'components/Container';
import { TitleWrapper, PageTitle, Content } from './style';

const ModulesContent: React.FC = () => {
  return (
    <>
      <SectionContainer>
        <TitleWrapper>
          <PageTitle alignXS="center">PRODUTOS</PageTitle>
          <SubTitle alignXS="center">
            Uma linha completa de suplementação para tentantes, gestantes e lactantes.
          </SubTitle>
        </TitleWrapper>
      </SectionContainer>
      <Content>
        <div className="content-tab">
          <Tab />
        </div>
        <div className="content-accordion">
          <AccordionUI />
        </div>
      </Content>
    </>
  );
};

export default ModulesContent;
